import { IconChevronDownCircle, IconRearrange } from '../../icons/svgs';
import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../AppContext';
import './index.scss';
import manager from '../../Manager';

function Content() {
    const {globalState, updateGlobalState} = useContext(AppContext);
    const {selectedIndex, slides, settings, values, progressData} = globalState;

    const selectedSlide = slides[selectedIndex];
    const lessonTitle = settings.lessonTitle;
    let selectedIndexLabel = slides.length > 0 ? selectedIndex+1 : 0;

    const handleNavPrev = async () => {
        if (selectedIndex === 0) {
            return false;
        }
        updateGlobalState('selectedIndex', selectedIndex-1);
    }
    const handleNavNext = async () => {
        if (!manager.inEditor) {
            // console.log('selectedIndexLabel ',selectedIndexLabel);
            // console.log('slidesLength ',slides.length);
            if (selectedIndexLabel >= slides.length) {
                return false;
            }
            let isBeforeNext=true;
            if(manager.options.onBeforeNextCallback) {
                isBeforeNext = await manager.runAsPromise(manager.options.onBeforeNextCallback, selectedIndex);
                // get response from result data, if progress page > current page, block arrow next. user can next by button Action Next
                if (typeof isBeforeNext == 'object') {
                    let progressPage = parseInt(isBeforeNext.progressPage);
                    if (selectedIndexLabel+1 > progressPage) {
                        isBeforeNext = false;
                    }
                }
            }

            if (isBeforeNext) {
                updateGlobalState('selectedIndex', selectedIndex+1);
                if(manager.options.onNextCallback) {
                    await manager.runAsPromise(manager.options.onNextCallback, selectedIndex+1, values );
                }
            }
        }
    }

    useEffect(() => {
        // detect first load lesson
        const onStart = async () => {
            let selectedIndexOnStart = selectedIndex;
            if (Object.keys(progressData).length !== 0 && progressData.constructor === Object) {
                let progressPageCurrentIndex = progressData.progressPageCurrentIndex;
                if (typeof progressPageCurrentIndex != 'undefined' && slides.length >= progressPageCurrentIndex) {
                    selectedIndexOnStart = progressData.progressPageCurrentIndex;
                }
            }
            await manager.runAsPromise(manager.options.onStartCallback, selectedIndexOnStart, slides[selectedIndexOnStart]);
        };
        onStart();
    }, []);

    const learnClass = () => {
        let learnClass = '';
        if(selectedSlide?.data?.platform) {
            learnClass = selectedSlide?.data?.platform;
        }
        return learnClass;
    }

  return (
    <div className={`tbcourse-content-preview learn ` + learnClass()}>
        <div className="tbcourse-content-preview-header">
            <div className="tbcourse-content-preview-header-navigator">
                {/* <button type='button' className="btn icon-rotate-90" onClick={handleNavPrev}>
                    <IconChevronDownCircle/>
                </button> */}
                <button type='button' className='btn btn-offcanvas' data-bs-toggle="offcanvas" data-bs-target="#tbcourse-table-of-content">
                    <IconRearrange/>
                </button>
            </div>
            <div className="tbcourse-content-preview-header-info">
                <span className="lesson-name" title={lessonTitle}>{lessonTitle}</span>
                <span>{selectedIndexLabel}/{slides.length}</span>
            </div>
            <div className="tbcourse-content-preview-header-navigator">
                {/* <button type='button' className="btn icon-rotate-270" onClick={handleNavNext}>
                    <IconChevronDownCircle/>
                </button> */}
            </div>
        </div>
        <div className="tbcourse-content-preview-body">
            {selectedSlide?.render()}
        </div>
        <div className='tbcourse-content-preview-footer'>
            {selectedSlide?.actions()}
        </div>
    </div>
  );
}

export default Content;
